<template>
    <div>
        <loading-custom :loading="loading" />
        <button
            type="button"
            class="btn btn-sm btn-dark"
            data-toggle="modal"
            data-target="#createSalepage"
        >
            <i class="fa fa-plus mr-2"></i> เพิ่ม Sale Page
        </button>

        <div class="modal" id="createSalepage" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title" id="createSalepageLabel">
                            <h5 class="mb-0">สร้าง Sale Page</h5>
                        </div>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group">
                            <label
                                >ประเภท Sale Page
                                <span class="tw-text-red-500"
                                    >* จำเป็นต้องกรอก</span
                                ></label
                            >
                            <div class="">
                                <select
                                    v-model="form.type"
                                    id="single-selection"
                                    name="single_selection"
                                    class="form-control"
                                >
                                    <option value="" disabled
                                        >---- เลือกประเภท Sale Page ----</option
                                    >
                                    <option value="info">ให้ข้อมูล</option>
                                    <option value="sale">การขาย</option>
                                    <option value="form">
                                        ฟอร์มเก็บข้อมูล
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group" v-if="imageSrc">
                            <img
                                :src="imageSrc"
                                class="user-photo media-object tw-w-full"
                                alt="User"
                            />
                        </div>
                        <div class="form-group">
                            <label>เพิ่มรูปภาพ</label>
                            <div
                                class="tw-text-xs tw-text-gray-500 col-12 mb-2 p-0"
                            >
                                <span>Recommended : 1200 x 730 pixels</span>
                            </div>
                            <button
                                type="button"
                                class="btn btn-default"
                                id="btn-upload-photo"
                                @click="uploadImage"
                            >
                                อัพโหลด
                            </button>
                            <input
                                type="file"
                                id="filePhoto"
                                class="sr-only"
                                @change="onFileChange"
                            />
                        </div>

                        <div class="form-group">
                            <label
                                >ชื่อเซลเพจ
                                <span class="tw-text-red-500"
                                    >* จำเป็นต้องกรอก</span
                                ></label
                            >
                            <count-character
                                :text="form.title"
                                :maxText="40"
                            ></count-character>
                            <input
                                v-model="form.title"
                                type="text"
                                class="form-control tw-placeholder-gray-300"
                                placeholder="Zavanna Shop"
                                required
                            />
                        </div>
                        <div class="form-group">
                            <label
                                >รายละเอียด
                                <span class="tw-text-red-500"
                                    >* จำเป็นต้องกรอก</span
                                ></label
                            >
                            <count-character
                                :text="form.description"
                                :maxText="255"
                            ></count-character>
                            <textarea
                                v-model="form.description"
                                class="form-control tw-placeholder-gray-300"
                                rows="3"
                                cols="30"
                                placeholder="รายละเอียด"
                                required
                            >
                            </textarea>
                        </div>
                        <div class="form-group">
                            <label
                                >Zavanna Slug
                                <span class="tw-text-red-500"
                                    >* จำเป็นต้องกรอก</span
                                ></label
                            >
                            <span class="help-block">
                                ( Ex. https://zavanna.co/<span
                                    v-show="!form.slug"
                                    class="tw-text-red-500"
                                    >zavannashop</span
                                ></span
                            ><span
                                :class="
                                    `${
                                        !status.slug
                                            ? 'tw-text-red-500'
                                            : 'tw-text-green-500'
                                    }`
                                "
                                >{{ formSlug }}</span
                            >
                            <span class="help-block"> )</span>
                            <br />
                            <span class="help-block"
                                >* ตั้งชื่อเป็นภาษาอังกฤษตัวเล็ก และ
                                ตัวเลขเท่านั้น
                            </span>

                            <input
                                v-model="form.slug"
                                type="text"
                                class="form-control tw-placeholder-gray-300"
                                placeholder="zavannashop"
                                @input="checkSlug()"
                                required
                            />
                        </div>
                        <div class="form-group">
                            <label>ชื่อโดเมน</label>
                            <br />
                            <span class="help-block">
                                * กรณีที่ร้านค้ามีโดเมนเป็นของตัวเอง
                            </span>
                            <span v-if="form.domain_url">
                                :
                                <span
                                    :class="
                                        `${
                                            !status.domain_url
                                                ? 'tw-text-red-500'
                                                : 'tw-text-green-500'
                                        }`
                                    "
                                >
                                    {{ form.domain_url }}
                                </span>
                            </span>
                            <input
                                v-model="form.domain_url"
                                type="text"
                                class="form-control tw-placeholder-gray-300"
                                placeholder="https://zavanna.co/"
                                @input="checkDomain()"
                            />
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-sm btn-default px-3"
                            data-dismiss="modal"
                        >
                            ยกเลิก
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-success px-3"
                            data-dismiss="modal"
                            @click="store"
                        >
                            บันทึก
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["shop"],
    data() {
        return {
            imageSrc: "",
            image: null,
            imageDir: "/salepage",
            loading: false,
            status: {
                slug: false,
                domain_url: false
            },
            form_required: {
                title: true,
                description: true,
                slug: true,
                domain_url: false,
                type: true
            },
            form: {
                title: "",
                description: "",
                slug: "",
                domain_url: "",
                type: ""
            }
        };
    },
    computed: {
        formSlug() {
            return this.form?.slug.toLowerCase();
        }
    },
    methods: {
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }

            const file_size = files[0].size / 1024 / 1024;
            const file_name = files[0].name;
            const re = /(\.jpg|\.jpeg|\.png)$/i;
            if (file_size > 2) {
                this.messageAlert(
                    "error",
                    "ขนาดภาพใหญ่ไปนะ",
                    "TwT ขอโทษนะ กรุณาใช้ภาพขนาดไม่เกิน 2mb"
                );
            } else if (!re.exec(file_name)) {
                this.messageAlert(
                    "error",
                    "ไฟล์นี้ใช้ไม่ได้นะ",
                    "TwT ขอโทษนะ กรุณาใช้รูปภาพประเภท jpg, jpeg, png"
                );
            } else {
                this.image = files[0];
                this.previewImage(files[0]);
            }
        },
        previewImage(file) {
            this.imageSrc = URL.createObjectURL(file);
        },
        uploadImage() {
            document.getElementById("filePhoto").click();
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        checkSlug: _.debounce(function(e) {
            if (this.form.slug.length >= 3) {
                axios
                    .get(
                        `/backend/s/${this.shop}/salepage/${this.form.slug}/slugs`
                    )
                    .then(res => {
                        this.status.slug = res.data.status;
                    })
                    .catch(err => {
                        this.status.slug = false;
                    });
            } else {
                this.status.slug = false;
            }
        }, 1000),
        checkDomain: _.debounce(function(e) {
            if (this.form.domain_url.length >= 3) {
                const re = new RegExp(
                    /^((?:(?:(?:\S[\.\-\+]?)*)\S)+)((?:(?:(?:\S[\.\-\+]?){0,62})\S)+)\.(\S{2,6})$/
                );
                const domain = this.getDomain(this.form.domain_url);
                if (re.test(domain)) {
                    this.status.domain_url = true;
                } else {
                    this.status.domain_url = false;
                }
            }
        }, 1000),
        getDomain(url, subdomain) {
            subdomain = subdomain || false;

            url = url.replace(/(https?:\/\/)?(www.)?/i, "");

            if (!subdomain) {
                url = url.split(".");

                url = url.slice(url.length - 2).join(".");
            }

            if (url.indexOf("/") !== -1) {
                return url.split("/")[0];
            }

            return url;
        },
        checkForm(data, required = {}) {
            let rs = false;
            Object.keys(data).map(item => {
                if (!data[item] && required[item]) {
                    rs = true;
                }
            });
            return rs;
        },
        store() {
            if (this.form.domain_url && !this.status.domain_url) {
                this.messageAlert(
                    "error",
                    "ชื่อโดเมนนี้ใช้ไม่ได้",
                    "กรุณากรอกชื่อโดเมนให้ถูกต้อง"
                );
            } else if (this.checkForm(this.form, this.form_required)) {
                this.messageAlert(
                    "error",
                    "ขอโทษค่ะ",
                    "กรุณากรอกข้อมูลให้ครบถ้วน"
                );
            } else if (this.form.title.length > 40) {
                this.messageAlert(
                    "error",
                    "ขอโทษค่ะ",
                    "ชื่อเซลเพจยาวไปนะ กรุณาเปลี่ยนชื่อเซลเพจ"
                );
            } else if (this.status.slug) {
                this.loading = true;

                let formData = new FormData();
                Object.keys(this.form).map(item => {
                    formData.append(
                        item,
                        this.form[item] ? this.form[item] : ""
                    );
                });
                formData.append("image", this.image ? this.image : "");

                axios
                    .post(`/backend/s/${this.shop}/salepages`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        window.location.reload();
                    })
                    .catch(err => {
                        this.messageAlert("error", "Sorry", "เกิดข้อผิดพลาด");
                    });
            } else if (!this.status.slug) {
                this.messageAlert(
                    "error",
                    "ไม่สามารถใช้ URL นี้ได้",
                    "URLไม่ถูกต้องหรือผู้อื่นใช้งานแล้วกรุณาเปลี่ยนก่อนทำรายการ"
                );
            }
        }
    }
};
</script>
